import React, { memo, forwardRef } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';

export const Card = memo(
  forwardRef(({ children, style, ...rest }, ref) => {
    const { styles } = useStyle();
    return (
      <View style={[styles.container, style]} {...rest} {...{ ref }}>
        {children}
      </View>
    );
  })
);

const useStyle = createUseStyle(({ colors, shadow }) => ({
  container: {
    backgroundColor: colors.white,
    borderRadius: 10,
    ...shadow.card,
    padding: 16,
    overflow: 'hidden',
  },
}));
